import type { SVGProps } from 'react';
type ZinniaSvgProps = SVGProps<SVGSVGElement> & {
  size: number | string,
};
const SvgMiscDomain = (props: ZinniaSvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    height={props.size}
    width={props.size}
    {...props}
  >
    <path
      stroke="#88827E"
      strokeWidth={2}
      d="M3 5h17v14H3.895V8h15.21M15.5 10.5l-5 5L8 13"
    />
  </svg>
);
export default SvgMiscDomain;
